import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-vip-crown-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-xl text-background-50">
                  六合宝典
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                玩家必备的权威参考工具，收录完整玩法规则、历史数据分析、号码走势图表及专业解读。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">
                内容分类
              </h4>
              <ul className="space-y-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/wanfa-jiexi"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    玩法解析
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/lishi-shuju"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    历史数据
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-100 mb-4">
                免责声明
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本站所有内容仅供信息参考，不构成任何投注建议。彩票开奖具有随机性，请理性娱乐，切勿沉迷。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 六合宝典 版权所有 | 仅供信息参考
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                rel="nofollow"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                rel="nofollow"
              >
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}